import React from 'react'
import { useNavigate } from 'react-router-dom'

import useCustomer from '../../../configuration/hooks/useCustomer'
import styled from '../../constants/theme'

export const CustomerLogo: React.FC = () => {
  const navigate = useNavigate()
  const { customerName, primaryLogoDark } = useCustomer()
  if (!primaryLogoDark) {
    return null
  }

  const handleClick = () => {
    // if we came from a marketing page we should have a referrer to go back to
    // as the "home" page for a11y, otherwise go to the root
    if (document.referrer.length > 0) {
      window.open(document.referrer, '_self')
    } else {
      navigate('/')
    }
  }

  return (
    <button onClick={handleClick}>
      <FullWidthImg alt={`${customerName} Logo`} src={primaryLogoDark} />
    </button>
  )
}

const FullWidthImg = styled.img({
  height: 'auto',
  width: '100%',
})
